module.exports = {"id":"225951","name":"Denis Bouanga","rating":"71","photo":"./data/images/photos/2/225951.png","club":{"name":"FC Lorient","logo":"./data/images/clubs/FCLorient.png"},"positions":["AD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DenisBouanga0.json
// module id = 1045
// module chunks = 0